module.exports = "/assets/data/71ff825866dfb9188729e4a9ac1e970b-L37.data.json";